"use client"
import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainEmployees from '../../components/admin/employees/MainEmployees'

const HomePage = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:pt-8">
     <MainEmployees/>
    </main>
  </div>
  )
}

export default HomePage
